/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
 
  SET_ITEMS(state, events) {
    // events.map(event => event.title = event.artisans.map(artisan => artisan.firstname+' '+artisan.lastname).join(','))
   // events.map(event => event.title = event.)
    state.events = events
  },

  SET_ITEMS_BY_ARTISAN(state, events) {
    state.my_events = events
  },
  

  UPDATE_ITEM(state, payload) {
    const ItemIndex = state.events.findIndex((p) => p.id == payload.id)
    Object.assign(state.events[ItemIndex], payload)
  }
 
}
